import { getHeaders } from './getHeaders';

const DEFAULT_BASE_URL = `https://${process.env.REACT_APP_API}.schmooze.tech`;

export const fetcher = async <T = any>(
  path: string,
  options: RequestInit = {},
  baseURL: string = DEFAULT_BASE_URL,
): Promise<T> => {
  const headers = {
    ...getHeaders(),
    ...(options.headers as Record<string, string>),
  };

  const response = await fetch(`${baseURL}${path}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: response.statusText }));
    throw error;
  }

  return response.json();
};
